"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCaption = void 0;
var React = require("react");
var Icon_1 = require("../../Icons/Icon/Icon");
var IconCaption_styles_1 = require("./IconCaption.styles");
var IconCaption = function (_a) {
    var SelectedIcon = _a.Icon, Caption = _a.Caption;
    return (React.createElement(IconCaption_styles_1.ContainerDiv, null,
        React.createElement(IconCaption_styles_1.IconContainerDiv, null,
            React.createElement(Icon_1.Icon, { Icon: SelectedIcon, Height: "24px", Width: "24px" })),
        React.createElement(IconCaption_styles_1.CaptionDiv, null, Caption)));
};
exports.IconCaption = IconCaption;
